// SideDrawer.js
import React, { useEffect } from 'react';
import { useFormStore } from '../../state/FormStore';
import { ConfigurationForm } from './ConfigurationForm';
import { SubConfigurationForm } from './SubConfigurationForm';

export const SideDrawer = ({ productData }) => {
    const { activeTab, setFormData, formData, calculateSizes, sizes } = useFormStore();

    useEffect(() => {
        calculateSizes();
    }, [])

    return (
        <>
            <div className='bg-gray-800 desktop-configurator text-white w-8/12 justify-between py-6 px-4 overflow-x-hidden overflow-y-scroll h-screen'>
                <ConfigurationForm productData={productData} />
            </div>
            <div className='bg-gray-800 desktop-configurator text-white w-4/12 justify-between py-2 px-2 overflow-x-hidden overflow-y-none h-screen'>
                <SubConfigurationForm />
            </div>
        </>

    );
};

export default SideDrawer;
